import Icon from '../components/Icon.vue'

Icon.register({"feather":{"width":512,"height":512,"paths":[{"d":"M512 0C504.8 0 98.5 22 71.5 287.4 68.8 310 67.3 332.7 66.1 355.4L226.8 194.8C233 188.5 243.1 188.5 249.4 194.8S255.6 211.1 249.4 217.4L9.4 457.4A31.9-31.9 0 0 1 0 480C0 497.7 14.3 512 32 512 40.2 512 48.4 508.9 54.6 502.6L109.7 447.6C148.1 447.1 186.4 444.9 224.6 440.5 236.2 439.3 247.1 437.2 257.8 434.7L256 384H357.9C370.5 373.4 382 361.6 392.6 348.9L384 288H434.2C502.8 163.6 512 0.1 512 0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/feather.js
// module id = pRRp
// module chunks = 0